import { render, staticRenderFns } from "./FooterSite.vue?vue&type=template&id=87aa8b90&lang=html&"
import script from "./FooterSite.vue?vue&type=script&lang=js&"
export * from "./FooterSite.vue?vue&type=script&lang=js&"
import style0 from "./FooterSite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports